import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { xpApi, formatCents } from "@/lib/experienceApi";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, ShoppingBag, ArrowRight } from "lucide-react";

export default function ExperienceAddonSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const orderId = params.get("order_id");

  useEffect(() => {
    if (!orderId) return;
    let tries = 0;
    const tick = async () => {
      try {
        const r = await xpApi.addonOrderStatus(orderId);
        setData(r);
        if (r.order?.status !== "paid" && tries < 10) {
          tries += 1;
          setTimeout(tick, 1000);
        }
      } catch {}
    };
    tick();
  }, [orderId]);

  if (!data) return <div className="p-6 text-center text-sm text-neutral-500">Vérification…</div>;
  const { order, items } = data;
  const paid = order?.status === "paid";

  return (
    <div className="max-w-xl mx-auto px-4 py-8">
      <div className="text-center mb-6">
        <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-3">
          <CheckCircle2 className="w-8 h-8 text-emerald-600" />
        </div>
        <h1 className="text-2xl font-display text-neutral-900">
          {paid ? "Commande confirmée" : "Paiement en cours…"}
        </h1>
        <p className="text-sm text-neutral-600 mt-2">
          Vos articles vous seront livrés par l'organisateur.
        </p>
      </div>

      <Card className="mb-3">
        <CardContent className="p-4">
          <div className="text-xs uppercase tracking-widest text-neutral-500 mb-2 flex items-center gap-1">
            <ShoppingBag className="w-3.5 h-3.5" /> Détail commande
          </div>
          <div className="grid gap-1 text-sm">
            {items.map(i => (
              <div key={i.id} className="flex justify-between">
                <span>{i.name} × {i.quantity}</span>
                <b>{formatCents(i.unit_price_cents * i.quantity, order.currency)}</b>
              </div>
            ))}
            <div className="border-t mt-2 pt-2 flex justify-between font-semibold">
              <span>Total</span>
              <span className="text-[#E5276A]">{formatCents(order.amount_gross_cents, order.currency)}</span>
            </div>
          </div>
        </CardContent>
      </Card>

      <Button onClick={() => nav("/experience/my")} className="w-full bg-[#E5276A] hover:bg-[#C01661]">
        Retour à mon espace <ArrowRight className="w-4 h-4 ml-2" />
      </Button>
    </div>
  );
}
